import { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eraser, Signature } from "lucide-react";

export const DataConsentSignDialog = ({ open, onOpenChange, patientName, onSign, submitting, kiosk,
    title = "Firmar consentimiento de protección de datos", allowRepresentative = true }) => {
    const sigRef = useRef(null);
    const [empty, setEmpty] = useState(true);
    const [signerType, setSignerType] = useState("patient");
    const [repName, setRepName] = useState("");

    useEffect(() => {
        if (open) {
            setEmpty(true); setSignerType("patient"); setRepName("");
            setTimeout(() => sigRef.current?.clear(), 40);
        }
    }, [open]);

    const submit = () => {
        if (!sigRef.current || sigRef.current.isEmpty()) return;
        onSign({
            signature_data_url: sigRef.current.getCanvas().toDataURL("image/png"),
            signer_type: signerType,
            signed_by_name: signerType === "representative" ? repName.trim() : patientName,
        });
    };
    const canSubmit = !empty && !submitting && (signerType === "patient" || repName.trim());
    const opt = (v, label) => (
        <button type="button" onClick={() => setSignerType(v)} data-testid={`dc-signer-${v}`}
            className={"flex-1 rounded-md border px-3 py-2 text-sm transition-colors " + (signerType === v ? "border-primary bg-primary/10 font-semibold" : "border-border hover:bg-secondary/40")}>
            {label}
        </button>
    );

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className={"max-w-2xl " + (kiosk ? "w-full" : "")} data-testid="dc-sign-dialog">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>Firma con el dedo o el lápiz dentro del recuadro.</DialogDescription>
                </DialogHeader>
                <div className="space-y-3">
                    {allowRepresentative && (
                        <div className="flex gap-2">
                            {opt("patient", `Firma el paciente${patientName ? ` (${patientName})` : ""}`)}
                            {opt("representative", "Firma un tutor o representante")}
                        </div>
                    )}
                    {signerType === "representative" && (
                        <div>
                            <Label className="text-xs">Nombre y apellidos del tutor/representante</Label>
                            <Input value={repName} onChange={(e) => setRepName(e.target.value)} data-testid="dc-rep-name" />
                        </div>
                    )}
                    <div className="rounded-md border border-border bg-white" style={{ touchAction: "none" }}>
                        <SignatureCanvas ref={sigRef} penColor="#111" onEnd={() => setEmpty(false)}
                            canvasProps={{ className: "w-full h-44", "data-testid": "dc-signature-canvas" }} />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => { sigRef.current?.clear(); setEmpty(true); }} data-testid="dc-signature-clear">
                        <Eraser size={14} className="mr-1" /> Borrar
                    </Button>
                    <Button className="btn-cta" disabled={!canSubmit} onClick={submit} data-testid="dc-signature-submit">
                        <Signature size={14} className="mr-1" /> {submitting ? "Generando PDF…" : "Firmar y terminar"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
